var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56262 22.7143C-0.85453 20.3261 -0.854519 15.2667 2.56263 12.8785L19.4263 1.09249C23.4033 -1.68707 28.8634 1.15831 28.8634 6.01043V11.1887H46.3145C50.4566 11.1887 53.8145 14.5466 53.8145 18.6887C53.8145 22.8309 50.4566 26.1887 46.3145 26.1887H28.8634V29.5824C28.8634 34.4345 23.4033 37.2799 19.4263 34.5003L2.56262 22.7143Z",
    fill: "#14AE5C",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 23,
    height: 3,
    rx: 1.5,
    fill: "#14AE5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 13.75,
    width: 21.5,
    height: 1.5,
    rx: 0.75,
    stroke: "#FAF9FB",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.84961,
    y: 12.064,
    width: 18.717,
    height: 3,
    rx: 1.5,
    transform: "rotate(-35.24 6.84961 12.064)",
    fill: "#FAF9FB",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15.4585,
    width: 4.26105,
    height: 3,
    rx: 1.5,
    transform: "rotate(-35.24 2 15.4585)",
    fill: "#FAF9FB",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.132a4c30c358d21667368d972d1f28d2.svg";
export { ForwardRef as ReactComponent };